/** DB modalidad_type ↔ UI labels */
export const MODALIDAD_TO_UI = {
  presencial: 'Presencial',
  virtual: 'Virtual',
};

export const MODALIDAD_TO_DB = {
  Presencial: 'presencial',
  Virtual: 'virtual',
  presencial: 'presencial',
  virtual: 'virtual',
};

export function modalidadToUi(modalidad) {
  return MODALIDAD_TO_UI[modalidad] || modalidad;
}

export function modalidadToDb(modalidad) {
  return MODALIDAD_TO_DB[modalidad] || String(modalidad || '').toLowerCase();
}

export function mapEventoFromDb(row) {
  if (!row) return null;
  return {
    ...row,
    modalidad: modalidadToUi(row.modalidad),
    enlace: row.link_virtual,
    isPast: new Date(row.fecha) < new Date(),
  };
}

export function mapRsvpFromDb(row) {
  if (!row) return null;
  return {
    id: row.id,
    eventId: row.evento_id,
    memberId: row.member_id,
  };
}

/** Build insert payload respecting modalidad_check constraint */
export function buildEventoInsertPayload(input, createdBy) {
  const modalidad = modalidadToDb(input.modalidad);
  const isVirtual = modalidad === 'virtual';
  const linkVirtual = input.link_virtual || input.enlace || null;
  const ubicacion = input.ubicacion || null;

  return {
    titulo: input.titulo,
    descripcion: input.descripcion || null,
    fecha: new Date(input.fecha).toISOString(),
    club_id: input.club_id || null,
    modalidad,
    ubicacion: isVirtual ? null : ubicacion,
    link_virtual: isVirtual ? linkVirtual : null,
    capitulo_id: input.capitulo_id || null,
    recording_training_id: input.recording_training_id || null,
    created_by: createdBy,
  };
}
